module.exports = __webpack_public_path__ + "static/media/icon_play.472fb755.svg";